module.exports = __webpack_public_path__ + "img/fu0001.ed714039.webp";